import { Button, Stack, Typography } from '@mui/material'
import { useAppDispatch } from '@/redux/hooks'
import { setAllActions } from '../../slice'
import type { FieldAction } from '../../types'

export default function AllEditActionButtons() {
  const dispatch = useAppDispatch()

  function handleClick(value: FieldAction) {
    dispatch(setAllActions(value))
  }

  return (
    <Stack>
      <Typography> Set all field actions: </Typography>
      <Stack direction="row">
        <Button onClick={() => handleClick('append')}> Append </Button>
        <Button onClick={() => handleClick('replace')}> Replace </Button>
      </Stack>
    </Stack>
  )
}
